import "./styles.sass";

import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Filter from "../../../components/filters/Filter";
import useFilters from "../../../customHooks/useFilters";
import UserDocs from "../userDocs/UserDocs";
import UserCalcs from "../userCalcs/UserCalcs";
import UserApplications from "../userApplic/UserApplications";
import Breadcrumbs from "../../../components/breadcrumbs/CHBreadcrubs";
import User from "./User";
import { Context } from "../../..";
import { observer } from "mobx-react-lite";
import { useSelectedUser } from "../../../customHooks/useSelectetUser";
import UserReports from "../userReports/userReports";
import BackButton from "../../../components/UI/button/BackButton";

const UserEdit = () => {
  const { users } = useContext(Context);
  const showFilter = useFilters();
  useSelectedUser();
  const allBlocks = [
    <User key="user" value="info" data={users.selectedUser} />,
    <UserDocs key="user-docs" value="docs" data={users}/>,
    <UserCalcs key="calc" value="calc" data={users.selectedUser.calc} />,
    <UserApplications
      key="applications"
      value="applications"
      data={users.selectedUser}
    />,
    <UserReports key="reports" value="reports" data={users} />,
  ];

  const isInList = (value: string) => {
    return (
      showFilter.checkedValues.includes(value) ||
      showFilter.checkedValues.includes("all")
    );
  };

  const setUserBlocks = () => {
    const blocksToshow: any = [];
    allBlocks.map((block) => {
      if (isInList(block.props.value)) {
        blocksToshow.push(block);
      }
    });
    return blocksToshow;
  };

  return (
    <div className="user-edit">
      <header className="user-edit-header">
        <div className="title-container">
          <BackButton />
          <div className="title"> User Edit</div>
        </div>
        {/* <Breadcrumbs paramsTitle={{ id: id }} /> */}
      </header>
      <div className="body">{setUserBlocks()}</div>
      <div className="filters">
        <Filter
          title="Show"
          list={[
            { label: "All", value: "all", default: true },
            { label: "User Information", value: "info", default: false },
            { label: "User documents", value: "docs" },
            { label: "User calculations", value: "calc" },
            { label: "User applicants", value: "applicants" },
            { label: "User applications", value: "applications" },
            { label: "User reports", value: "reports" },
          ]}
          onSelect={showFilter.handleSelect}
        />
      </div>
    </div>
  );
};

export default observer(UserEdit);
